import { UserType } from "@/constants";

/**
 * Source for "I am the …" / "The registrant is the …" NAC copy on license flows.
 * Registrants use their session account API; operators/government use the license's
 * registrant_account (includes primary_account_* for secondary users).
 */
export function accountDataForNacRegistrantCopy(
  userType: UserType,
  licenseRegistrantAccount: unknown,
  registrantApiAccount: unknown,
): unknown {
  if (userType === UserType.REGISTRANT) {
    return registrantApiAccount;
  }
  return licenseRegistrantAccount ?? undefined;
}
